// extracted by mini-css-extract-plugin
export default {"tip":"TipHolder_tip__jBlfT","apy":"TipHolder_apy__58K9E"};